// Helpers de contrato (Renovações) e farol do cliente, compartilhados entre
// Kanban e Follow-ups.

const MONTHS_PT = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez",
];

const MONTHS_PT_FULL = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

/** Nome do mês em que o alerta dispara (um mês antes do fim do contrato). */
export function alertMonthLabel(ym: string): string {
  if (!ym) return "";
  const [year, month] = ym.split("-").map(Number);
  if (!year || !month) return "";
  // mês anterior ao vencimento (base 0: month-2)
  let idx = month - 2;
  if (idx < 0) idx += 12;
  return MONTHS_PT_FULL[idx];
}

/** Meses até o fim do contrato ('YYYY-MM'). Negativo = já vencido. */
export function monthsUntilContractEnd(ym: string): number | null {
  if (!ym) return null;
  const [year, month] = ym.split("-").map(Number);
  if (!year || !month) return null;
  const now = new Date();
  return (year - now.getFullYear()) * 12 + (month - (now.getMonth() + 1));
}

/** Avisa a partir de 1 mês antes do vencimento (inclui vencidos). */
export function contractInAviso(ym: string): boolean {
  const n = monthsUntilContractEnd(ym);
  return n !== null && n <= 1;
}

/** 'YYYY-MM' → 'Out/2026'. */
export function formatContractMonth(ym: string): string {
  if (!ym) return "";
  const [year, month] = ym.split("-").map(Number);
  if (!year || !month) return ym;
  return `${MONTHS_PT[month - 1]}/${year}`;
}

export const FAROL_COLORS: Record<string, { dot: string; label: string }> = {
  verde: { dot: "#22C55E", label: "Cliente saudável, renovação provável" },
  amarelo: { dot: "#F59E0B", label: "Atenção — engajamento caindo" },
  vermelho: { dot: "#EF4444", label: "Risco de churn, ação imediata" },
};
